// extracted by mini-css-extract-plugin
export var content = "_sd-1";
export var wrapper = "_sd-0";